// extracted by mini-css-extract-plugin
export default {"coverWrapper":"kkOpHH","cover":"HNM0p2","thumbContainer":"KUUi4M","thumbWrapper":"zhlgK5"};